import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { loadConfig } from '@anna/anna-ws-server-library';

import App from './App';

import configureStore from './store';
import { init as initApi } from './common/api';
import ApiClientInstance from './common/ApiClient';

import './index.css';

function getCompanyId(location) {
  const pathItems = location.pathname.split('/');
  return pathItems[1] === 'company' && pathItems[2] !== 'xero' ? pathItems[2] : null;
}

loadConfig().then((config) => {
  const { location } = window;
  ApiClientInstance.appApiUrl = config.appApiUrl;
  ApiClientInstance.authUrl = config.authUrl;
  ApiClientInstance.websiteUrl = config.websiteUrl;
  ApiClientInstance.publicApiUrl = config.publicApiUrl;
  const configWithToken = {
    ...config,
    token: 'cookie',
  };
  const store = configureStore({
    appService: {
      config: configWithToken,
      companyId: getCompanyId(location),
    },
  });

  initApi(configWithToken);

  const { googleAnalyticsId } = config;
  if (googleAnalyticsId) {
    window.ga('create', googleAnalyticsId, 'auto');
    window.ga('send', 'pageview');
  }

  ReactDOM.render(
    <Provider store={store}><App /></Provider>,
    document.getElementById('root'),
  );
});
